import { render, staticRenderFns } from "./chateau-pouget.vue?vue&type=template&id=636ac078&scoped=true"
import script from "./chateau-pouget.vue?vue&type=script&lang=js"
export * from "./chateau-pouget.vue?vue&type=script&lang=js"
import style0 from "./chateau-pouget.vue?vue&type=style&index=0&id=636ac078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636ac078",
  null
  
)

export default component.exports